import { mapDataSource, RawDataSource } from '~/Api/DataSource';
import Price from '~/utils/Price';

import { CeilingPrice } from './CeilingPrice';

interface RawCeilingPriceProduct {
	id: string;
	dataSource: RawDataSource;
}

export interface RawCeilingPrice {
	currency: string;
	value: string;
	fromProducts: RawCeilingPriceProduct[];
}

export const mapCeilingPrice = (ceilingPrice: RawCeilingPrice): CeilingPrice => ({
	price: new Price(ceilingPrice.value, ceilingPrice.currency),
	fromProducts: ceilingPrice.fromProducts.map((product) => ({
		id: product.id,
		dataSource: mapDataSource(product.dataSource),
	})),
});
